import { io, Socket } from 'socket.io-client'

export default defineNuxtPlugin((nuxtApp) => {
    const getWssUrl = () => {
        if (process.server) {
          // На сервере определяем URL на основе заголовка host
          const host = nuxtApp.ssrContext?.event.node.req.headers.host || ''
          
          if (host === 'yourservice.ae') {
            return 'wss://backend-prod-bhlfzy4vpq-ez.a.run.app'
          } else {
            return 'wss://backend-dev-bhlfzy4vpq-ez.a.run.app'
          }
        } else {
          const hostname = window.location.hostname
          
          if (hostname === 'yourservice.ae') {
            return 'wss://backend-prod-bhlfzy4vpq-ez.a.run.app'
          } else {
            return 'wss://backend-dev-bhlfzy4vpq-ez.a.run.app'
          }
        }
    }

    // Создаем два разных экземпляра сокета
    const socketUnread: Socket = io(getWssUrl(), {
        autoConnect: false,
        transports: ['websocket']
    })

    const socketMessages: Socket = io(getWssUrl(), {
        autoConnect: false,
        transports: ['websocket']
    })

    return {
        provide: {
            ioUnread: socketUnread,
            ioMessages: socketMessages
        }
    }
})

